<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    :width="size"
    :height="size"
  >
    <circle
      :cx="cx"
      :cy="cy"
      :r="r"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      fill="none"
    />
    <circle
      :cx="cx"
      :cy="cy"
      :r="innerR"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      fill="none"
    />
  </svg>
</template>
<script>
export default {
  name: 'icon-circle-double',
  props: {
    size: {
      type: Number,
      default: 16,
    },
    stroke: {
      type: String,
      default: '#606266',
    },
    strokeWidth: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    cx() {
      return this.size / 2
    },
    cy() {
      return this.size / 2
    },
    r() {
      return this.size / 2 - this.strokeWidth / 2
    },
    innerR() {
      return (this.size / 2 - this.strokeWidth / 2) / 2
    },
  },
}
</script>